import AssetsPage from "components/dashboard/assets-page";
import { FunctionComponent } from "react";

interface MaterialsPageProps {}

const MaterialsPage: FunctionComponent<MaterialsPageProps> = () => {
  return <AssetsPage assetType="material" />;
};

export default MaterialsPage;
